import React from 'react';
import { Container, Typography, Box, Link, Stack, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import SEO from '../components/SEO';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO 
        title={t('contact.title')}
        url="https://band-space.com/contact/"
        canonical="https://band-space.com/contact/"
      />
      <Container maxWidth="md" sx={{ py: 4, pb: { xs: 8, md: 10 } }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            {t('contact.title')}
          </Typography>
          
          <Stack spacing={3} sx={{ mt: 4 }}>
            <Box>
              <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon />
                {t('contact.supportEmail')}
              </Typography>
              <Link href="mailto:support@band-space.com" color="primary" underline="hover">
                support@band-space.com
              </Link>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <InstagramIcon />
                {t('contact.instagram')}
              </Typography>
              <Link href="https://www.instagram.com/band_space_official/" target="_blank" rel="noopener noreferrer" color="primary" underline="hover">
                @band_space_official
              </Link>
            </Box>
          </Stack>
        </Paper>
      </Container>
    </>
  );
};

export default Contact; 